class Reach {
  constructor() {
    this.aReachArr = this.aReachArr.bind(this);
    this.transfer = this.transfer.bind(this);
  }

  transfer = () => {
    let arr = [
      ["Bangladesh", "65,000", "15,167", "0", "0", "32,500", "7,583"],
      ["Cambodia", "80,000", "18,667", "0", "0", "40,000", "9,333"],
      [
        "Hong Kong",
        "2,000,000",
        "466,667",
        "358,980",
        "83,762",
        "1,179,490",
        "275,214",
      ],
      [
        "Japan",
        "4,500,000",
        "1,050,000",
        "23,396,700",
        "5,459,230",
        "13,948,350",
        "3,254,615",
      ],
      [
        "Korea",
        "1,100,000",
        "256,667",
        "1,205,117",
        "281,194",
        "1,152,559",
        "268,930",
      ],
      ["Laos", "14,000", "3,267", "0", "0", "7,000", "1,633"],
      [
        "Malaysia",
        "448,000",
        "104,533",
        "790,954",
        "184,556",
        "619,477",
        "144,545",
      ],
      ["Myanmar", "228,000", "53,200", "0", "0", "114,000", "26,600"],
      ["Pakistan", "151,000", "35,233", "45,514", "10,620", "98,257", "22,927"],
      [
        "Philippines",
        "450,000",
        "105,000",
        "95,631",
        "22,314",
        "272,816",
        "63,657",
      ],
      [
        "Singapore",
        "1,700,000",
        "396,667",
        "550,024",
        "128,339",
        "1,125,012",
        "262,503",
      ],
      [
        "Taiwan",
        "1,700,000",
        "396,667",
        "343,059",
        "80,047",
        "1,021,529",
        "238,357",
      ],
      [
        "Thailand",
        "890,000",
        "207,667",
        "440,387",
        "102,757",
        "665,194",
        "155,212",
      ],
      [
        "Austria",
        "900,000",
        "210,000",
        "280,907",
        "65,545",
        "590,454",
        "137,773",
      ],
      ["Bulgaria", "83,000", "19,367", "0", "0", "41,500", "9,683"],
      [
        "Czech Republic",
        "458,000",
        "106,867",
        "80,580",
        "18,802",
        "269,290",
        "62,834",
      ],
      [
        "Finland",
        "1,900,000",
        "443,333",
        "316,487",
        "73,847",
        "1,108,244",
        "258,590",
      ],
      ["Greece", "450,000", "105,000", "57,390", "13,391", "253,695", "59,196"],
      [
        "Hungary",
        "233,000",
        "54,367",
        "317,970",
        "74,193",
        "275,485",
        "64,280",
      ],
      [
        "Norway",
        "11,900,000",
        "2,776,667",
        "3,676,701",
        "857,897",
        "7,788,351",
        "1,817,282",
      ],
      [
        "Romania",
        "153,000",
        "35,700",
        "154,260",
        "35,994",
        "153,630",
        "35,847",
      ],
      [
        "Sweden",
        "22,000,000",
        "5,133,333",
        "3,228,476",
        "753,311",
        "12,614,238",
        "2,943,322",
      ],
      [
        "Argentina",
        "324,000",
        "75,600",
        "2,827,654",
        "659,786",
        "1,575,827",
        "367,693",
      ],
      ["Bolivia", "29,000", "6,767", "279,716", "65,267", "154,358", "36,017"],
      [
        "Chile",
        "232,000",
        "54,133",
        "1,518,154",
        "354,236",
        "875,077",
        "204,185",
      ],
      [
        "Dominican Republic",
        "40,000",
        "9,333",
        "790,123",
        "184,362",
        "415,061",
        "96,848",
      ],
      ["Panama", "52,000", "12,133", "212,914", "49,680", "132,457", "30,907"],
      [
        "Paraguay",
        "28,000",
        "6,533",
        "442,324",
        "103,209",
        "235,162",
        "54,871",
      ],
      ["Uruguay", "39,000", "9,100", "290,199", "67,713", "164,599", "38,407"],
      ["Venezuela", "35,000", "8,167", "0", "0", "17,500", "4,083"],
      ["Egypt", "123,000", "28,700", "251,983", "58,796", "187,491", "43,748"],
      ["Jordan", "43,000", "10,033", "0", "0", "21,500", "5,017"],
      ["Kuwait", "72,000", "16,800", "111,836", "26,095", "91,918", "21,448"],
      ["Oman", "59,000", "13,767", "46,796", "10,919", "52,898", "12,343"],
      ["Qatar", "131,000", "30,567", "0", "0", "65,500", "15,283"],
      [
        "Saudi Arabia",
        "443,000",
        "103,367",
        "377,134",
        "87,998",
        "410,067",
        "95,682",
      ],
      [
        "Turkey",
        "510,000",
        "119,000",
        "4,082,023",
        "952,472",
        "2,296,011",
        "535,736",
      ],
      ["UAE", "923,000", "215,367", "555,879", "129,705", "739,439", "172,536"],
      ["Bosnia and Herzegovina", "-", "-", "-", "-", "41,500", "9,683"],
      ["Croatia", "-", "-", "-", "-", "41,500", "9,683"],
      ["Cyprus", "-", "-", "-", "-", "41,500", "9,683"],
      ["Montenegro", "-", "-", "-", "-", "41,500", "9,683"],
      ["Serbia", "-", "-", "-", "-", "41,500", "9,683"],
    ];
    let res = {};
    arr.map((a) => {
      res[a[0]]={
        "monthly": a[5],
        "weekly": a[6]
      }
      // console.log(a[0])
      return true
    });
     console.log(res)

    return res
  };

  aReachArr = () => {
    let res = {
      "Bangladesh": {
        "monthly": "32,500",
        "weekly": "7,583"
      },
      "Cambodia": {
        "monthly": "40,000",
        "weekly": "9,333"
      },
      "Hong Kong": {
        "monthly": "1,179,490",
        "weekly": "275,214"
      },
      "Japan": {
        "monthly": "13,948,350",
        "weekly": "3,254,615"
      },
      "Korea": {
        "monthly": "1,152,559",
        "weekly": "268,930"
      },
      "Laos": {
        "monthly": "7,000",
        "weekly": "1,633"
      },
      "Malaysia": {
        "monthly": "619,477",
        "weekly": "144,545"
      },
      "Myanmar": {
        "monthly": "114,000",
        "weekly": "26,600"
      },
      "Pakistan": {
        "monthly": "98,257",
        "weekly": "22,927"
      },
      "Philippines": {
        "monthly": "272,816",
        "weekly": "63,657"
      },
      "Singapore": {
        "monthly": "1,125,012",
        "weekly": "262,503"
      },
      "Taiwan": {
        "monthly": "1,021,529",
        "weekly": "238,357"
      },
      "Thailand": {
        "monthly": "665,194",
        "weekly": "155,212"
      },
      "Austria": {
        "monthly": "590,454",
        "weekly": "137,773"
      },
      "Bulgaria": {
        "monthly": "41,500",
        "weekly": "9,683"
      },
      "Czech Republic": {
        "monthly": "269,290",
        "weekly": "62,834"
      },
      "Finland": {
        "monthly": "1,108,244",
        "weekly": "258,590"
      },
      "Greece": {
        "monthly": "253,695",
        "weekly": "59,196"
      },
      "Hungary": {
        "monthly": "275,485",
        "weekly": "64,280"
      },
      "Norway": {
        "monthly": "7,788,351",
        "weekly": "1,817,282"
      },
      "Romania": {
        "monthly": "153,630",
        "weekly": "35,847"
      },
      "Sweden": {
        "monthly": "12,614,238",
        "weekly": "2,943,322"
      },
      "Argentina": {
        "monthly": "1,575,827",
        "weekly": "367,693"
      },
      "Bolivia": {
        "monthly": "154,358",
        "weekly": "36,017"
      },
      "Chile": {
        "monthly": "875,077",
        "weekly": "204,185"
      },
      "Dominican Republic": {
        "monthly": "415,061",
        "weekly": "96,848"
      },
      "Panama": {
        "monthly": "132,457",
        "weekly": "30,907"
      },
      "Paraguay": {
        "monthly": "235,162",
        "weekly": "54,871"
      },
      "Uruguay": {
        "monthly": "164,599",
        "weekly": "38,407"
      },
      "Venezuela": {
        "monthly": "17,500",
        "weekly": "4,083"
      },
      "Egypt": {
        "monthly": "187,491",
        "weekly": "43,748"
      },
      "Jordan": {
        "monthly": "21,500",
        "weekly": "5,017"
      },
      "Kuwait": {
        "monthly": "91,918",
        "weekly": "21,448"
      },
      "Oman": {
        "monthly": "52,898",
        "weekly": "12,343"
      },
      "Qatar": {
        "monthly": "65,500",
        "weekly": "15,283"
      },
      "Saudi Arabia": {
        "monthly": "410,067",
        "weekly": "95,682"
      },
      "Turkey": {
        "monthly": "2,296,011",
        "weekly": "535,736"
      },
      "UAE": {
        "monthly": "739,439",
        "weekly": "172,536"
      },
      "Bosnia and Herzegovina": {
        "monthly": "41,500",
        "weekly": "9,683"
      },
      "Croatia": {
        "monthly": "41,500",
        "weekly": "9,683"
      },
      "Cyprus": {
        "monthly": "41,500",
        "weekly": "9,683"
      },
      "Montenegro": {
        "monthly": "41,500",
        "weekly": "9,683"
      },
      "Serbia": {
        "monthly": "41,500",
        "weekly": "9,683"
      }
    };
    
    return res;
  };
}
export default Reach;
